import React from 'react';
import { push } from 'connected-react-router';
import { batch, useDispatch } from 'react-redux';
import './AboutYou.css';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { INTAKE_SECTION_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import Button from 'new-ui/Components/Button';
import AboutYouGfx from 'assets/gfx/about_you.svg';
import { closePopups } from 'modules/popup/actions';
import { INTAKE_SECTIONS } from 'new-ui/Components/Intake/questions';

export const AboutYouPopup = () => {
  const dispatch = useDispatch();
  return (
    <div className="about-you-popup">
      <div className="about-you-popup-image">
        <img src={AboutYouGfx} alt="" width="292" height="224" />
      </div>
      <div className="padding-20">
        <div className="about-you-popup-title">
          Information About You
        </div>
        <div className="about-you-popup-text">
          Please update information about you to help us tailor our services to better suit your needs.
        </div>
        <div className="about-you-popup-button">
          <Button
            title="Update"
            action={() => {
              batch(() => {
                dispatch(closePopups());
                dispatch(push(
                  `${ROUTE_PATH[ROUTE_NAME.INTAKE]}?${INTAKE_SECTION_URL_SEARCH_PARAM}=${INTAKE_SECTIONS.ABOUT_YOU}`,
                ));
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};
